import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive } from '@nuxtjs/composition-api'
import AlertLayout from './AlertLayout.vue'
import { AlertConfig } from './types'


export default /*#__PURE__*/_defineComponent({
  __name: 'Alert',
  setup(__props, { expose }) {

const isOpen = ref(false)
const config = reactive<AlertConfig>({ title: '', buttonTitle: '확인' })

const buttonRef = ref(null)

const open = (param: AlertConfig) => {
  config.title = param.title ?? ''
  config.contents = param.contents ?? ''
  if (param.buttonTitle) {
    config.buttonTitle = param.buttonTitle
  }
  config.action = param.action

  isOpen.value = true

  const button: any = buttonRef.value
  button && button.$el.focus()
}

const close = () => {
  isOpen.value = false
}

const handleClick = () => {
  config.action && config.action()
  close()
}

expose({ open, close })

return { __sfc: true,isOpen, config, buttonRef, open, close, handleClick, AlertLayout }
}

})